/**
 * MechaGuard - UI 格式化工具
 *
 * 放在单独模块里，避免同一段格式化逻辑在多个 UI 组件里各写一份
 * （之前 main.js 与排行榜面板都需要「秒 -> m:ss」）。
 */

/**
 * 秒 -> `m:ss`
 * @param {number} seconds
 */
export function formatTime(seconds) {
  const total = Math.max(0, Math.floor(Number(seconds) || 0));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}

/**
 * 时间戳 -> `YYYY-MM-DD HH:mm`
 * @param {number} ts 毫秒时间戳
 */
export function formatDate(ts) {
  const n = Number(ts);
  if (!Number.isFinite(n) || n <= 0) return '—';

  const d = new Date(n);
  const pad = v => String(v).padStart(2, '0');

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} `
    + `${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** 大数字加千分位，便于阅读分数 */
export function formatNumber(value) {
  const n = Math.round(Number(value) || 0);
  return n.toLocaleString('en-US');
}
